import type { UserData } from '../api';
import type { UseUserDataParams } from '../hooks/types';
import { BackInStockNotificationChannel } from '../models';

export const onUserDataFetchSuccess =
  ({ currentType, setInputData }: UseUserDataParams) =>
  (fetchedData: UserData) => {
    if (fetchedData.email && currentType === BackInStockNotificationChannel.Email) {
      setInputData(fetchedData.email);
    } else if (fetchedData.telephoneNumber && currentType === BackInStockNotificationChannel.Sms) {
      setInputData(fetchedData.telephoneNumber);
    }
  };
